import { UserProfileI } from 'declarations/interfaces/user';

declare global {
  interface Window {
    pendo?: {
      initialize: (options: PendoInitializeOptions) => void;
      isReady: () => boolean;
    };
  }
}

interface PendoVisitor {
  id: string;
}

interface PendoAccount {
  id: string;
  app?: string;
  app_id?: string;
}

interface PendoInitializeOptions {
  visitor: PendoVisitor;
  account: PendoAccount;
}

/**
 * Initialize Pendo with basic user data for resource center
 */
export const initializePendo = (userProfile: UserProfileI): void => {
  if (typeof window === 'undefined' || !window.pendo) {
    console.warn('Pendo is not loaded yet');
    return;
  }

  try {
    window.pendo.initialize({
      visitor: {
        id: userProfile.id,
      },
      account: {
        id: 'chirp',
        app: 'Chirp',
        app_id: 'chirp',
      },
    });
    console.log('Pendo initialized successfully for Chirp');
  } catch (error) {
    console.error('Failed to initialize Pendo:', error);
  }
};
